
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ide-praktik/kategori",
      function () {
        return require("private-next-pages/ide-praktik/kategori/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ide-praktik/kategori"])
      });
    }
  